import React from 'react';
import './App.css';
import {BrowserRouter as Router,Switch,Route, Redirect} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Index from './pages/index.jsx'
import Usuarios from './pages/usuarios.jsx'
import Empresa from './pages/empresa.jsx'
import Nosotros from './pages/nosotros.jsx'
import Aviso from './pages/aviso.jsx'
import Plantilla from './pages/plantilla.jsx'


function App() {
  return (
    <Router>
      <Switch>
        <Route path="/index">
          <Index />
        </Route>
        <Route path="/users">
          <Usuarios />
        </Route>
        <Route path="/company">
          <Empresa/>
        </Route>
        <Route path="/we">
          <Nosotros />
        </Route>
        <Route path="/privacy">
          <Aviso />
        </Route>
        <Route path="/plantilla">
          <Plantilla />
        </Route>
        <Route path="/">
          <Index />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;